import React from "react";
import "./styles.less";

export const Switch = ({ checked, onChange, disabled } : { checked: boolean, onChange: (checked: boolean) => void, disabled?: boolean }) => {
    return (
        <div className="switch_item">
            <label className="switch_wrap">
                <input
                    type="checkbox"
                    name="switch"
                    className="switch_inp"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled ?? false}
                />
                <span className="switch_mark"></span>
            </label>
        </div>
    )
}